import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_ButtonGroup = _resolveComponent("ButtonGroup")
  const _component_BuilderInputs = _resolveComponent("BuilderInputs")
  const _component_Segment = _resolveComponent("Segment")

  return ($props.collapsible && !$data.collapsed)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "title collapse pointer",
        onClick: _cache[0] || (_cache[0] = $event => ($data.collapsed = true))
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("span", null, "+", -1 /* HOISTED */)),
        _createElementVNode("span", null, _toDisplayString($props.title), 1 /* TEXT */)
      ]))
    : (_openBlock(), _createBlock(_component_Segment, {
        key: 1,
        title: $props.title,
        raised: "",
        padded: "",
        form: "",
        style: _normalizeStyle($props.style)
      }, _createSlots({
        default: _withCtx(() => [
          _createVNode(_component_BuilderInputs, {
            "vread-from": "valid",
            "onUpdate:valid": $event => (($data.valid) = $event),
            opts: $options.input_items,
            gap: $props.gap,
            onUpdate: _cache[2] || (_cache[2] = (prop) => _ctx.$emit('update', prop))
          }, null, 8 /* PROPS */, ["onUpdate:valid", "opts", "gap"])
        ]),
        _: 2 /* DYNAMIC */
      }, [
        ($props.collapsible)
          ? {
              name: "header-left",
              fn: _withCtx(() => [
                _createElementVNode("div", {
                  class: "title pointer",
                  onClick: _cache[1] || (_cache[1] = $event => ($data.collapsed = false))
                }, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", null, "-", -1 /* HOISTED */)),
                  _createElementVNode("span", null, _toDisplayString($props.title), 1 /* TEXT */)
                ])
              ]),
              key: "0"
            }
          : undefined,
        ($props.tabs)
          ? {
              name: "header-right",
              fn: _withCtx(() => [
                _createVNode(_component_ButtonGroup, { type: "outlined" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tabs, (tab) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: tab.value,
                        class: _normalizeClass(["tab-btn", {active: $data.current_tab === tab.value}]),
                        onClick: $event => ($data.current_tab = tab.value)
                      }, [
                        _createVNode(_component_Icon, {
                          icon: tab.icon,
                          width: "2rem",
                          height: "2rem",
                          class: "tab-icon"
                        }, null, 8 /* PROPS */, ["icon"])
                      ], 10 /* CLASS, PROPS */, _hoisted_1))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              key: "1"
            }
          : undefined
      ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["title", "style"]))
}